import { ca } from '@cian/analytics';

export function trackShowMobileReliabilityBlock() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'Show_sopr',
    label: 'reliability',
    useLastProducts: true,
  });
}
